import { AmortizationTypeProvider } from "domain/AmortizationType";
import { CategoriesProvider } from "domain/Category";
import { CensusProvider } from "domain/Census";
import { CompaniesProvider } from "domain/Company";
import { FiltersProvider } from "domain/Filters";
import { SmallInventoryValueProvider } from "domain/SmallInventoryValue";
import { SortingProvider } from "domain/Sorting";
import { SuppliersProvider } from "domain/Supplier/context";
import { ExportProvider } from "..";
import { InventoryActionsProvider } from "domain/Inventory/context";

export const ExportPageProvider = ({ children }) => (
  <SortingProvider>
    <FiltersProvider>
      <CategoriesProvider>
        <CompaniesProvider>
          <CensusProvider>
            <SuppliersProvider>
              <SmallInventoryValueProvider>
                <AmortizationTypeProvider>
                  <ExportProvider>
                    <InventoryActionsProvider>
                      {children}
                    </InventoryActionsProvider>
                  </ExportProvider>
                </AmortizationTypeProvider>
              </SmallInventoryValueProvider>
            </SuppliersProvider>
          </CensusProvider>
        </CompaniesProvider>
      </CategoriesProvider>
    </FiltersProvider>
  </SortingProvider>
);
